import { ROUTE_NAME } from "../router/types/CommonTypes";

export const LOCALIZATIONS = [
  {
    key: "[GMT+04:00] Abu Dhabi",
    value: "Asia/Dubai",
  },
  {
    key: "[GMT-05:00] Eastern Time",
    value: "America/New_York",
  },
  {
    key: "[GMT-06:00] Central Time",
    value: "America/Chicago",
  },
  {
    key: "[GMT-07:00] Mountain Time",
    value: "America/Denver",
  },
  {
    key: "[GMT-07:00] Arizona",
    value: "America/Phoenix",
  },
  {
    key: "[GMT-08:00] Pacific Time",
    value: "America/Los_Angeles",
  },
  {
    key: "[GMT-09:00] Alaska",
    value: "America/Anchorage",
  },
  {
    key: "[GMT-10:00] Hawaii",
    value: "Pacific/Honolulu",
  },
  {
    key: "[GMT-04:00] Atlantic Time",
    value: "America/Halifax",
  },
];

export const COUNTRIES = [
  {
    key: "United Arab Emirates (UAE)",
    value: "United Arab Emirates (UAE)",
  },
  {
    key: "United States (US)",
    value: "United States (US)",
  },
];

export const ROOM_TYPES = [
  {
    key: "Operating Room / Theatre",
    value: "Operating Room / Theatre",
  },
];

export const REFRESH_TOKEN_BEFORE_TIME = 30 * 1000; // 30 seconds

export const PASSWORD_CRITERIA = [
  "Minimum_8_characters",
  "At_least_one_uppercase_letter",
  "At_least_one_lowercase_letter",
  "At_least_one_number",
  "At_least_one_special_character",
];

export const ALERT_MESSAGES: Record<string, string> = {
  "Delay in Progress firstCase":
    "Notify if the scheduled start time has passed and the patient has not yet been marked in room.",
  "Delay in Progress subsequentCase":
    "Notify if the scheduled start time has passed and the patient has not yet been marked in room.",
  "late start":
    "Notify when the patient enters the room after a delay.",
  "Ready for Surgeon": "Notify when Patient is ready for Surgeon.",
  "Ready for Anesthesiologist":
    "Notify when patient is ready for Anesthesiologist.",
  "Ready For Room Clean":
    "Notify when the patient is wheeled out and the room is ready for cleaning",
  "Risk of Turnover Time Delay":
    "Notify when the Turnover Time surpasses the benchmark.",
  "Subsequent case late start":
    "Notify when the patient enters the room after a delay.",
  "Subsequent case ready for surgeon":
    "Notify when patient is ready for surgeon.",
  "Subsequent case ready for anesthesiologists":
    "Notify when room is ready for anesthesiologists.",
  "Subsequent case ready for cleaning":
    "Notify after wheels out that the room is ready to be cleaned",
  "Case Running Long":
    "Notify when a case is running longer than scheduled end time. ",
  "SMS (Custom Messages)":
    "Nurses can send voice-first, transcribed messages as SMS alerts to users by Name, Role, and Department. Orva user roles receive department-level messages as outlined here:",
  "Surgeon Conflict Alerts":
    "Inform if surgeon is still in operative time of a given case and next assigned case starts within [minutes].",
  "Anesthesiologist Conflict Alerts firstCase":
    "Inform if the anesthesiologist is still overseeing a patient (awaiting Ready to Exit) and has another assigned case starting within [X] minutes.",
  "Anesthesiologist Conflict Alerts subsequentCase":
    "Inform if anesthesiologist is still overseeing incubated patient",
  "Equipment Conflict Alerts":
    "Inform if required [equipment] is still in use for a given case and the next assigned case starts within [X minutes].",
    "Case Not Close Alerts":
      "Notify when a case is not close after the scheduled end time.",
};

export const INFORM_AFTER = [
  {
    key: "5 minutes",
    value: "5 minutes",
  },
  {
    key: "10 minutes",
    value: "10 minutes",
  },
  {
    key: "15 minutes",
    value: "15 minutes",
  },
  {
    key: "20 minutes",
    value: "20 minutes",
  },
  {
    key: "25 minutes",
    value: "25 minutes",
  },
  {
    key: "30 minutes",
    value: "30 minutes",
  },
  {
    key: "35 minutes",
    value: "35 minutes",
  },
];

export const START_WITHIN = [
  {
    key: "15 minutes",
    value: "15 minutes",
  },
  {
    key: "30 minutes",
    value: "30 minutes",
  },
  {
    key: "45 minutes",
    value: "45 minutes",
  },
  {
    key: "60 minutes",
    value: "60 minutes",
  },
];

// Milestone Types
export const MILESTONE_TYPES = {
  SURGEON: "surgeon",
} as const;

// Inform At Options for different milestone types
export const INFORM_AT_OPTIONS = {
  [MILESTONE_TYPES.SURGEON]: [
    { key: "Wheels In", value: "Wheels In" },
    { key: "Patient Ready", value: "Patient Ready" },
  ],
  roomClean: [{ key: "Wheels Out", value: "Wheels Out" }],
};

// Legacy constants for backward compatibility
export const INFORM_AT = INFORM_AT_OPTIONS[MILESTONE_TYPES.SURGEON];

export const RECIPIENTS = [
  {
    key: "Charge Nurse",
    value: "Charge Nurse",
  },
  {
    key: "OT Manager",
    value: "OT Manager",
  },
  {
    key: "Surgeon assigned",
    value: "Surgeon assigned",
  },
  {
    key: "Anesthesiologist assigned",
    value: "Anesthesiologist assigned",
  },
];

export const UP_TO = [
  {
    key: "1",
    value: "1",
  },
  {
    key: "2",
    value: "2",
  },
  {
    key: "3",
    value: "3",
  },
  {
    key: "4",
    value: "4",
  },
];

export type OPTION_TYPE = {
  label: string;
  value: number;
};

export const DEFAULT_TIME_ZONE = "Asia/Dubai";

export const API_DATA_LIMIT = 100;

export const CODING_ADMIN_ROUTES_ACCESS = [
  ROUTE_NAME.CASE_MANAGEMENT,
  ROUTE_NAME.CODING,
  ROUTE_NAME.CODING_RECOMMENDATION,
  ROUTE_NAME.CODING_CASE_DETAIL,
  ROUTE_NAME.USER_ACCOUNT,
  ROUTE_NAME.SUPPORT,
];

export const NURSE_ROUTES_ACCESS = [
  ROUTE_NAME.CASE_BOARD
];

export const SURGEON_ROUTES_ACCESS = [
  ROUTE_NAME.CASE_MANAGEMENT,
  ROUTE_NAME.CODING,
  ROUTE_NAME.CODING_CASE_DETAIL,
  ROUTE_NAME.CODING_RECOMMENDATION,
];
export const STATUS = {
  ACTIVE: "Active",
  DEACTIVATED: "Deactivated",
  PENDING: "Pending",
  INCOMPLETE: "Incomplete",
};
export const defaultDuration = { hours: "", mins: "", secs: "" };

export enum GENDER {
  MALE = "Male",
  FEMALE = "Female",
}

export const GENDER_LIST = [
  { key: GENDER.MALE, value: GENDER.MALE },
  { key: GENDER.FEMALE, value: GENDER.FEMALE },
];

export const PATIENT_TYPE = [
  {
    key: "INPATIENT",
    value: "INPATIENT",
  },
  {
    key: "DAYSURGERY",
    value: "DAYSURGERY",
  }
];
/**
 * Socket event names
 */
export const SOCKET_EVENTS = {
  /** Case-related events (case created/updated/submitted, etc.) */
  CASE_EVENTS: "case-events",
  PREDICTION_EVENTS: "case-prediction-event",

} as const;

/**
 * Socket event types from backend.
 * Used to handle different types of case-events from the socket.
 */
export enum EventTypeEnum {
  UPSERT_CASE = 'UPSERT_CASE',
  UPDATE_CASE = 'UPDATE_CASE',
  DELETE_CASE = 'DELETE_CASE',
  RESET_CASE = 'RESET_CASE',
  UPDATE_CASE_STATUS = 'UPDATE_CASE_STATUS',
  UPDATE_MILESTONES = 'UPDATE_MILESTONES',
  GET_CASES = 'GET_CASES',
  GET_CASE_BY_ID = 'GET_CASE_BY_ID',
  ERROR = 'ERROR',
  UNKNOWN_EVENT = 'UNKNOWN_EVENT',
  SUBMIT_CASE = 'SUBMIT_CASE',
  KNOCK_OUT = 'KNOCK_OUT',
  LOGOUT = 'LOGOUT',
  DOCUMENTATION_PROCESSING_QUEUED = 'DOCUMENTATION_PROCESSING_QUEUED',
  DOCUMENTATION_PROCESSING_COMPLETED = 'DOCUMENTATION_PROCESSING_COMPLETED',
}

/**
 * Socket event payload structure (from backend).
 */
export type SocketEventPayload = {
  eventType: EventTypeEnum;
  sessionId?: string;
  userId?: string | number;
  otId?: string;
  userName?: string;
  caseId?: string;
  [key: string]: any; // Additional event-specific fields
};
